export default __webpack_public_path__ + "static/media/folder.32ca9399.svg";